import React from 'react';
import { Box } from '@mui/material';
import { DEFAULT_TABLE_LAYOUT_CONFIG } from '../shared/defaultTableRegistry';

/** System-managed tables own separate columns/toolbars while sharing only visual primitives. */
export default function DefaultTableLayout({ tableKey, config = DEFAULT_TABLE_LAYOUT_CONFIG, children, ...props }) {
  return <Box data-table-layout="default" data-table-key={tableKey} data-table-density={config.density} sx={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }} {...props}>{children}</Box>;
}
